// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3mrQ4","right":"Footer_right__2PCgs","buttons":"Footer_buttons__2wl4d"};